export const PATIENT_EXPERIENCE_LOGIN_METHODS = {
  FN_TRIGGER_LOGIN: "FN_TRIGGER_LOGIN",
  CLIENT_PORTAL_REDIRECTION: "CLIENT_PORTAL_REDIRECTION"
};
